import { ApiListResult } from "../types/ApiResults";
import { Application } from "../types/Application";
import { Contact, EvaluationStatus } from "../types/Contact";
import { convertApplicationToContact, convertRatingToScore, convertStatusToEtat } from "./converter";

const headers = {
    "Content-Type": "application/json",
    credentials: "include"
}

export const loadContacts = async (jobId: number): Promise<Contact[]> => {
    return new Promise((resolve, reject) => {
        fetch(`/api/job/${jobId}/applications`, {
            method: "GET",
            headers
        }).then(response => {
            return response.json();
        }).then((data: ApiListResult<Application>) => {
            const applications = data.Value;

            resolve(applications.map(application => {
                return convertApplicationToContact(application);
            }));
        }).catch(error => {
            reject(error);
        })
    });
};

export interface ContactUpdatePayload {
    status?: EvaluationStatus;
    rating?: number | null;
} 

export const updateContact = async (contact: Contact, payload: ContactUpdatePayload): Promise<Contact> => {
    // Build the payload
    const body = {
        etat: payload.status ? convertStatusToEtat(payload.status) : convertStatusToEtat(contact.evaluation.status),
        score: payload.rating ? convertRatingToScore(payload.rating) : convertRatingToScore(contact.evaluation.rating)
    }

    return new Promise((resolve, reject) => {
        fetch(`/api/applications/${contact.id}`, {
            method: "POST",
            headers,
            body: JSON.stringify(body)
        }).then(response => {
            return response.json();
        }).then((application: Application) => {
            resolve(convertApplicationToContact(application));
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchMotivationLetter = async (contact: Contact): Promise<string> => {
    return new Promise((resolve, reject) => {
        fetch(`/api/applications/${contact.id}/motivationLetter`, {
            method: "GET",
            headers
        }).then(response => {
            return response.json();
        }).then((data: { motivation: string }) => {
            resolve(data.motivation);
        }).catch(error => {
            reject(error);
        })
    });
}

export const updateContactNotes = async (contact: Contact, notes: string): Promise<Contact> => {
    const body = {
        notes
    }

    return new Promise((resolve, reject) => {
        fetch(`/api/applications/${contact.id}/notes`, {
            method: "POST",
            headers,
            body: JSON.stringify(body)
        }).then(response => {
            return response.json();
        }).then((application: Application) => {
            resolve(convertApplicationToContact(application));
        }).catch(error => {
            reject(error);
        })
    });
}

export const sendContactMessage = async (contact: Contact, message: string): Promise<Contact> => {
    const body = {
        message
    }

    return new Promise((resolve, reject) => {
        fetch(`/api/applications/${contact.id}/message`, {
            method: "POST",
            headers,
            body: JSON.stringify(body)
        }).then(response => {
            return response.json();
        }).then((application: Application) => {
            resolve(convertApplicationToContact(application));
        }).catch(error => {
            reject(error);
        })
    });
}

export const fetchDefaultContactMessage = async (contact: Contact): Promise<string> => {
    return new Promise((resolve, reject) => {
        fetch(`/api/applications/${contact.id}/defaultMessage`, {
            method: "GET",
            headers
        }).then(response => {
            return response.json();
        }).then((data: { message: string }) => {
            resolve(data.message);
        }).catch(error => {
            reject(error);
        })
    });
}